
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type interchangesRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function interchangesRT(): TemplateResult<interchangesRTRootProps> {
    function repeatPart1(productInterchanges, part, partIndex) {
        return _createElement('button', {
            'className': 'cm_interchange-button' + (partIndex === 0 ? ' cm_interchange-button-active' : ''),
            'onClick': e => window.Convermax.handlePDPTableTabs(e, part.PartNumber, 'cm_interchange')
        }, '\n      ', part.Title, '\n    ');
    }
    function scopeBrandNamePartNumbersIsHidden2(productInterchanges, part, partIndex, interchanges, isCollapsible, interchange, interchangeIndex) {
        var brandName = interchange[0];
        var partNumbers = interchange[1];
        var isHidden = interchangeIndex > 4;
        return _createElement('div', {
            'cm-data-hidden': isHidden ? 'true' : 'false',
            'className': 'fitment-row' + (isHidden ? ' cm_hide' : '')
        }, _createElement('div', { 'className': 'fitment-cell' }, _createElement('div', { 'className': 'fitment-cell__value' }, brandName)), _createElement('div', { 'className': 'fitment-cell' }, _createElement('div', { 'className': 'fitment-cell__value' }, partNumbers)));
    }
    function repeatInterchange3(productInterchanges, part, partIndex, interchanges, isCollapsible, interchange, interchangeIndex, brandName, partNumbers, isHidden) {
        return scopeBrandNamePartNumbersIsHidden2.apply(this, [
            productInterchanges,
            part,
            partIndex,
            interchanges,
            isCollapsible,
            interchange,
            interchangeIndex
        ]);
    }
    function scopeInterchangesIsCollapsible4(productInterchanges, part, partIndex) {
        var interchanges = Object.entries(part.Values);
        var isCollapsible = interchanges.length > 4;
        return [
            _createElement.apply(this, [
                'div',
                {
                    'className': 'fitment-table-body fitment-table-body-collapsible fitment-table-fitment' + (isCollapsible ? ' cm_fitment-table-body-content-collapsed' : ''),
                    'key': '9581'
                },
                _createElement('div', { 'className': 'fitment-row' }, _createElement('div', { 'className': 'fitment-cell' }, _createElement('div', { 'className': 'fitment-cell__value' }, 'Brand Name')), _createElement('div', { 'className': 'fitment-cell' }, _createElement('div', { 'className': 'fitment-cell__value' }, 'Part #'))),
                _map(interchanges, repeatInterchange3.bind(this, productInterchanges, part, partIndex, interchanges, isCollapsible))
            ]),
            isCollapsible ? _createElement('div', {
                'className': 'cm_fitment-table_collapse-button-container',
                'key': '9583'
            }, _createElement('button', {
                'className': 'cm_fitment-table_collapse-button btn btn--primary',
                'onClick': e => window.Convermax.showMoreProductData(e)
            }, '\n              Show More\n            ')) : null
        ];
    }
    function repeatPart5(productInterchanges, part, partIndex) {
        return _createElement('div', { 'className': 'cm_interchange-content cm_interchange-content-' + part.PartNumber + (partIndex === 0 ? ' cm_interchange-content-active' : '') }, _createElement('div', { 'className': 'cm_fitment-table__horizontal' }, scopeInterchangesIsCollapsible4.apply(this, [
            productInterchanges,
            part,
            partIndex
        ])));
    }
    function scopeProductInterchanges6() {
        var productInterchanges = JSON.parse(this.productData[0].value);
        return _createElement('div', {
            'className': 'cm_interchange cm_fitment-table',
            'key': '0'
        }, _createElement('div', { 'className': 'cm_interchange-header' }, _createElement('span', { 'className': 'cm_interchange-header-title' }, 'INTERCHANGE')), productInterchanges.length > 1 ? _createElement.apply(this, [
            'div',
            {
                'className': 'cm_interchange-actions',
                'key': '266'
            },
            _map(productInterchanges, repeatPart1.bind(this, productInterchanges))
        ]) : null, _createElement.apply(this, [
            'div',
            { 'className': 'cm_interchange-content-container' },
            _map(productInterchanges, repeatPart5.bind(this, productInterchanges))
        ]));
    }
    return this.productData.length ? scopeProductInterchanges6.apply(this, []) : null;
}
        export const componentNames = []